import { render } from "./DemoCustomButton.vue?vue&type=template&id=17ab7ad4&scoped=true"
import script from "./DemoCustomButton.vue?vue&type=script&lang=js"
export * from "./DemoCustomButton.vue?vue&type=script&lang=js"

import "./DemoCustomButton.vue?vue&type=style&index=0&id=17ab7ad4&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ab7ad4"]])

export default __exports__